import React from 'react';

import Skeleton from '../../Skeleton';
import { Card } from '../../UI';

import { Container } from './styles';

const LoadingBalanceCashbackCards: React.FC = () => {
  return (
    <Container>
      <Card.Wraper>
        <div className="alignCards">
          <Card.Box flex={2} className="cashbackCard">
            <Card.Text>
              <Skeleton className="row-skeleton description" />
            </Card.Text>
            <Card.Title>
              <Skeleton className="row-skeleton title" />
            </Card.Title>
            <Skeleton className="row-skeleton button" />
          </Card.Box>
          <Card.Box flex={2} className="cashbackCard">
            <Card.Text>
              <Skeleton className="row-skeleton description" />
            </Card.Text>
            <Card.Title>
              <Skeleton className="row-skeleton title" />
            </Card.Title>
            <Card.Action href="#">
              <Skeleton className="row-skeleton action" />
            </Card.Action>
          </Card.Box>
        </div>
        <Card.Box className="cashbackCard">
          <Card.Text>
            <Skeleton className="row-skeleton description" />
          </Card.Text>
          <Card.Title>
            <Skeleton className="row-skeleton title" />
          </Card.Title>
          <Card.Action href="#">
            <Skeleton className="row-skeleton action" />
          </Card.Action>
        </Card.Box>
      </Card.Wraper>
    </Container>
  );
};

export default LoadingBalanceCashbackCards;
